import classNames from "classnames";
import React, { ReactNode } from "react";

import Button, { ButtonProps } from "../Button/Button";
import styles from "./StickyDrawer.module.scss";
import PaymentStripe from "../PaymentStripe";

interface StickyDrawerProps {
  children?: ReactNode;
  primaryButtonText?: string;
  primaryButtonProps?: ButtonProps;
  secondaryButtonText?: string;
  secondaryButtonProps?: ButtonProps;
  className?: string;
  isHideFooter?: boolean;
}

const StickyDrawer = React.forwardRef(
  (
    {
      children,
      primaryButtonText,
      primaryButtonProps,
      secondaryButtonText,
      secondaryButtonProps,
      className,
      isHideFooter,
    }: StickyDrawerProps,
    ref?: React.LegacyRef<HTMLDivElement>
  ) => {
    return (
      <div className={styles.sticky_drawer} ref={ref}>
        <div className={classNames(styles.container, className)}>
          {children}
          {!isHideFooter && (
            <div className="sticky bottom-0 w-full bg-white py-2 flex  gap-1">
              {primaryButtonText && (
                <Button
                  {...primaryButtonProps}
                  className={classNames(
                    primaryButtonProps?.className,
                    "flex-1"
                  )}
                >
                  {primaryButtonText}
                </Button>
              )}
              {secondaryButtonText && (
                <Button
                  type="outline"
                  variant="secondary"
                  {...secondaryButtonProps}
                  className={classNames(
                    secondaryButtonProps?.className,
                    "flex-1"
                  )}
                >
                  {secondaryButtonText}
                </Button>
              )}
            </div>
          )}
        </div>
      </div>
    );
  }
);

StickyDrawer.displayName = "StickyDrawer";

export default StickyDrawer;
